import axios from 'axios';

const baseURL = process.env.REACT_APP_BASE_URL || 'http://localhost:3000';

const apiClient = axios.create({
  baseURL,
  headers: {
    Accept: 'application/json'
  }
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    const message = error.response?.data?.message || error.message || 'Unexpected error';
    const err = new Error(message);
    // attach status and response body for callers that need them
    err.status = error.response?.status;
    err.data = error.response?.data;
    return Promise.reject(err);
  }
);

export const apiService = {
  get: (url, config) => apiClient.get(url, config),
  post: (url, data, config) => apiClient.post(url, data, config),
  put: (url, data, config) => apiClient.put(url, data, config),
  delete: (url, config) => apiClient.delete(url, config)
};

export default apiClient;
